import { useSelector as reduxUseSelector } from 'react-redux';
import { RootState } from '..';
import { FeatureFlagSelector } from './selectors';

export const createFeatureFlagHooks = (useSelector: typeof reduxUseSelector) => ({
  useFeatureFlags: () => useSelector((state: RootState) => FeatureFlagSelector.getFeatures(state)),
  useIsFeatureFlagEnabled: (key: string, defaultValue?: boolean) => useSelector((state: RootState) => FeatureFlagSelector.isFeatureFlagEnabled(state, key, defaultValue)),
  useFeatureFlagVariant: <T>(key: string, defaultValue: T) => useSelector((state: RootState) => FeatureFlagSelector.getVariant<T>(state, key, defaultValue)),
});